import dayjs from 'dayjs';

const nameOfMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const getMonthName = (month: number) => nameOfMonths[month - 1];

export const formatDateTimeFromUTC = (
  utcDate?: Date | string | null,
  withTime: boolean = false,
  format: string = 'MMMM D, YYYY',
) => {
  if (!utcDate) {
    return '';
  }

  const hasTimeInFormat =
    format.includes('h:mm') || format.includes('HH:mm') || format.includes('A');
  const timeFormat = withTime && !hasTimeInFormat ? ' h:mm A' : '';
  const fullFormat = format + timeFormat;
  const localDate = dayjs(utcDate).format(fullFormat);

  return localDate;
};

export const getRemainingTime = (date: string) => {
  const now = dayjs();
  const target = dayjs(date);
  const remainingMinutes = target.diff(now, 'minute');
  const remainingHours = remainingMinutes / 60;

  const minutes = remainingMinutes + 'm';
  const hours = Math.floor(remainingHours) + 'h';
  return remainingHours < 1 ? minutes : hours;
};
